var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.innerVisible, title: _vm.title, width: "600px" },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.closeHandler
      }
    },
    [
      _c("div", { staticClass: "edi-check-result-display single-row-style" }, [
        _c("img", { attrs: { src: _vm.falseIcon } }),
        _c("div", { staticStyle: { "padding-left": "20px" } }, [
          _vm._v(_vm._s(_vm.params.labelText))
        ])
      ]),
      _vm._l(_vm.dataSource, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "edi-check-item-renderer",
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "margin-top": "5px",
              "margin-bottom": "2px",
              padding: "1.5px",
              "align-items": "center"
            },
            attrs: { data: item }
          },
          [
            _c("div", { staticStyle: { "flex-grow": "1" } }, [
              _vm._v(_vm._s(item.name))
            ]),
            item.type === "failure"
              ? _c("img", { attrs: { src: _vm.icon, height: "16px" } })
              : _vm._e()
          ]
        )
      }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "close", type: "danger" },
              on: { click: _vm.closeHandler }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Close")))]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }